import React from 'react';
import BFLogo from '@assets/images/logos/primary_dark.png';

const renderCancel = (stage) => {
  if (stage < 3) {
    return (
      <a href="/pricing" className="cancel-link link">
        <label className="close-icon">
          <span className="bff-close" />
        </label>
        <h4 className="link">Cancel</h4>
      </a>
    );
  }

  return undefined;
};

const Header = (props) => (
  <header>
    <a
      href="https://brandfolder.com"
      target="_blank"
      rel="noopener noreferrer"
    >
      <img src={BFLogo} alt="Brandfolder logo" />
    </a>
    <h4>Your Brand's Potential Starts Here</h4>
    {renderCancel(props.stage)}
  </header>
);

export default Header;
